import React, { memo, useEffect } from 'react';

import { Box } from '@chakra-ui/react';

import { ResourceMetadataPage } from 'containers/ActiveCloudResource/Components/ResourceMetadataPage';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';

export const ActiveCloudResource = memo(() => {
  useEffect(() => {
    return () => console.log('unmounted');
  }, []);
  return (
    <ActiveResourceProvider>
      <Box>
        <ResourceMetadataPage />
      </Box>
    </ActiveResourceProvider>
  );
});
